import { CurrencyDisplay, CurrencyInputOptions } from "vue-currency-input"

export const MAX_NUMBER_OF_TREES = 3
export const WHAT_3_WORDS_REGEX = /^(?:\/\/\/)?[a-z]+\.[a-z]+\.[a-z]+$/
export const UK_CENTER = { lat: 54.432394, lng: -2.479169 } as const

export const UK_PHONE_ASCII_REGEX = /^[0-9+\s()\-]*$/
export const NOTES_ALLOWED_CHARS_REGEX = /^[a-zA-Z0-9 .,!?'()\-@#&:;"]*$/

export const CURRENCY_OPTIONS: CurrencyInputOptions = {
  currency: "GBP",
  locale: "en-GB",
  currencyDisplay: CurrencyDisplay.symbol,
  valueRange: { min: 0, max: 9999 },
  precision: 2,
  hideCurrencySymbolOnFocus: true,
  hideGroupingSeparatorOnFocus: true,
  hideNegligibleDecimalDigitsOnFocus: true,
  autoDecimalDigits: false,
  useGrouping: true,
  accountingSign: false,
}
